export const countries = [
  { code: 'AD', label: 'Andorra', phone: '376', translate: 'Andorra' },
  { code: 'AE', label: 'United Arab Emirates', phone: '971', translate: 'Emiratos Árabes Unidos' },
  { code: 'AF', label: 'Afghanistan', phone: '93', translate: 'Afganistán' },
  { code: 'AG', label: 'Antigua and Barbuda', phone: '1-268', translate: 'Antigua y Barbuda' },
  { code: 'AI', label: 'Anguilla', phone: '1-264', translate: 'Anguila' },
  { code: 'AL', label: 'Albania', phone: '355', translate: 'Albania' },
  { code: 'AM', label: 'Armenia', phone: '374', translate: 'Armenia' },
  { code: 'AO', label: 'Angola', phone: '244', translate: 'Angola' },
  { code: 'AQ', label: 'Antarctica', phone: '672', translate: 'Antártida' },
  { code: 'AR', label: 'Argentina', phone: '54', translate: 'Argentina' },
  { code: 'AS', label: 'American Samoa', phone: '1-684', translate: 'Samoa Americana' },
  { code: 'AT', label: 'Austria', phone: '43', translate: 'Austria' },
  { code: 'AU', label: 'Australia', phone: '61', translate: 'Australia' },
  { code: 'AW', label: 'Aruba', phone: '297', translate: 'Aruba' },
  { code: 'AX', label: 'Alland Islands', phone: '358', translate: 'Islas Åland' },
  { code: 'AZ', label: 'Azerbaijan', phone: '994', translate: 'Azerbaiyán' },
  { code: 'BA', label: 'Bosnia and Herzegovina', phone: '387', translate: 'Bosnia y Herzegovina' },
  { code: 'BB', label: 'Barbados', phone: '1-246', translate: 'Barbados' },
  { code: 'BD', label: 'Bangladesh', phone: '880', translate: 'Bangladés' },
  { code: 'BE', label: 'Belgium', phone: '32', translate: 'Bélgica' },
  { code: 'BF', label: 'Burkina Faso', phone: '226', translate: 'Burkina Faso' },
  { code: 'BG', label: 'Bulgaria', phone: '359', translate: 'Bulgaria' },
  { code: 'BH', label: 'Bahrain', phone: '973', translate: 'Baréin' },
  { code: 'BI', label: 'Burundi', phone: '257', translate: 'Burundi' },
  { code: 'BJ', label: 'Benin', phone: '229', translate: 'Benín' },
  { code: 'BL', label: 'Saint Barthelemy', phone: '590', translate: 'San Bartolomé' },
  { code: 'BM', label: 'Bermuda', phone: '1-441', translate: 'Bermudas' },
  { code: 'BN', label: 'Brunei Darussalam', phone: '673', translate: 'Brunéi' },
  { code: 'BO', label: 'Bolivia', phone: '591', translate: 'Bolivia' },
  { code: 'BR', label: 'Brazil', phone: '55', translate: 'Brasil' },
  { code: 'BS', label: 'Bahamas', phone: '1-242', translate: 'Bahamas' },
  { code: 'BT', label: 'Bhutan', phone: '975', translate: 'Bután' },
  { code: 'BV', label: 'Bouvet Island', phone: '47', translate: 'Isla Bouvet' },
  { code: 'BW', label: 'Botswana', phone: '267', translate: 'Botsuana' },
  { code: 'BY', label: 'Belarus', phone: '375', translate: 'Bielorrusia' },
  { code: 'BZ', label: 'Belize', phone: '501', translate: 'Belice' },
  { code: 'CA', label: 'Canada', phone: '1', translate: 'Canadá' },
  { code: 'CC', label: 'Cocos (Keeling) Islands', phone: '61', translate: 'Islas Cocos' },
  {
    code: 'CD',
    label: 'Congo, Democratic Republic of the',
    phone: '243',
    translate: 'República Democrática del Congo',
  },
  {
    code: 'CF',
    label: 'Central African Republic',
    phone: '236',
    translate: 'República Centroafricana',
  },
  { code: 'CG', label: 'Congo, Republic of the', phone: '242', translate: 'República del Congo' },
  { code: 'CH', label: 'Switzerland', phone: '41', translate: 'Suiza' },
  { code: 'CI', label: "Cote d'Ivoire", phone: '225', translate: 'Costa de Marfil' },
  { code: 'CK', label: 'Cook Islands', phone: '682', translate: 'Islas Cook' },
  { code: 'CL', label: 'Chile', phone: '56', translate: 'Chile' },
  { code: 'CM', label: 'Cameroon', phone: '237', translate: 'Camerún' },
  { code: 'CN', label: 'China', phone: '86', translate: 'China' },
  { code: 'CO', label: 'Colombia', phone: '57', translate: 'Colombia' },
  { code: 'CR', label: 'Costa Rica', phone: '506', translate: 'Costa Rica' },
  { code: 'CU', label: 'Cuba', phone: '53', translate: 'Cuba' },
  { code: 'CV', label: 'Cape Verde', phone: '238', translate: 'Cabo Verde' },
  { code: 'CW', label: 'Curacao', phone: '599', translate: 'Curazao' },
  { code: 'CX', label: 'Christmas Island', phone: '61', translate: 'Isla de Navidad' },
  { code: 'CY', label: 'Cyprus', phone: '357', translate: 'Chipre' },
  { code: 'CZ', label: 'Czech Republic', phone: '420', translate: 'República Checa' },
  { code: 'DE', label: 'Germany', phone: '49', translate: 'Alemania' },
  { code: 'DJ', label: 'Djibouti', phone: '253', translate: 'Yibuti' },
  { code: 'DK', label: 'Denmark', phone: '45', translate: 'Dinamarca' },
  { code: 'DM', label: 'Dominica', phone: '1-767', translate: 'Dominica' },
  { code: 'DO', label: 'Dominican Republic', phone: '1-809', translate: 'República Dominicana' },
  { code: 'DZ', label: 'Algeria', phone: '213', translate: 'Argelia' },
  { code: 'EC', label: 'Ecuador', phone: '593', translate: 'Ecuador' },
  { code: 'EE', label: 'Estonia', phone: '372', translate: 'Estonia' },
  { code: 'EG', label: 'Egypt', phone: '20', translate: 'Egipto' },
  { code: 'EH', label: 'Western Sahara', phone: '212', translate: 'Sáhara Occidental' },
  { code: 'ER', label: 'Eritrea', phone: '291', translate: 'Eritrea' },
  { code: 'ES', label: 'Spain', phone: '34', translate: 'España' },
  { code: 'ET', label: 'Ethiopia', phone: '251', translate: 'Etiopía' },
  { code: 'FI', label: 'Finland', phone: '358', translate: 'Finlandia' },
  { code: 'FJ', label: 'Fiji', phone: '679', translate: 'Fiyi' },
  { code: 'FK', label: 'Falkland Islands (Malvinas)', phone: '500', translate: 'Islas Malvinas' },
  { code: 'FM', label: 'Micronesia, Federated States of', phone: '691', translate: 'Micronesia' },
  { code: 'FO', label: 'Faroe Islands', phone: '298', translate: 'Islas Feroe' },
  { code: 'FR', label: 'France', phone: '33', translate: 'Francia' },
  { code: 'GA', label: 'Gabon', phone: '241', translate: 'Gabón' },
  { code: 'GB', label: 'United Kingdom', phone: '44', translate: 'Reino Unido' },
  { code: 'GD', label: 'Grenada', phone: '1-473', translate: 'Granada' },
  { code: 'GE', label: 'Georgia', phone: '995', translate: 'Georgia' },
  { code: 'GF', label: 'French Guiana', phone: '594', translate: 'Guayana Francesa' },
  { code: 'GG', label: 'Guernsey', phone: '44', translate: 'Guernsey' },
  { code: 'GH', label: 'Ghana', phone: '233', translate: 'Ghana' },
  { code: 'GI', label: 'Gibraltar', phone: '350', translate: 'Gibraltar' },
  { code: 'GL', label: 'Greenland', phone: '299', translate: 'Groenlandia' },
  { code: 'GM', label: 'Gambia', phone: '220', translate: 'Gambia' },
  { code: 'GN', label: 'Guinea', phone: '224', translate: 'Guinea' },
  { code: 'GP', label: 'Guadeloupe', phone: '590', translate: 'Guadalupe' },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '240', translate: 'Guinea Ecuatorial' },
  { code: 'GR', label: 'Greece', phone: '30', translate: 'Grecia' },
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    phone: '500',
    translate: 'Georgias del Sur y Sandwich del Sur',
  },
  { code: 'GT', label: 'Guatemala', phone: '502', translate: 'Guatemala' },
  { code: 'GU', label: 'Guam', phone: '1-671', translate: 'Guam' },
  { code: 'GW', label: 'Guinea-Bissau', phone: '245', translate: 'Guinea-Bisáu' },
  { code: 'GY', label: 'Guyana', phone: '592', translate: 'Guyana' },
  { code: 'HK', label: 'Hong Kong', phone: '852', translate: 'Hong Kong' },
  {
    code: 'HM',
    label: 'Heard Island and McDonald Islands',
    phone: '672',
    translate: 'Islas Heard y McDonald',
  },
  { code: 'HN', label: 'Honduras', phone: '504', translate: 'Honduras' },
  { code: 'HR', label: 'Croatia', phone: '385', translate: 'Croacia' },
  { code: 'HT', label: 'Haiti', phone: '509', translate: 'Haití' },
  { code: 'HU', label: 'Hungary', phone: '36', translate: 'Hungría' },
  { code: 'ID', label: 'Indonesia', phone: '62', translate: 'Indonesia' },
  { code: 'IE', label: 'Ireland', phone: '353', translate: 'Irlanda' },
  { code: 'IL', label: 'Israel', phone: '972', translate: 'Israel' },
  { code: 'IM', label: 'Isle of Man', phone: '44', translate: 'Isla de Man' },
  { code: 'IN', label: 'India', phone: '91', translate: 'India' },
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '246',
    translate: 'Territorio Británico del Océano Índico',
  },
  { code: 'IQ', label: 'Iraq', phone: '964', translate: 'Irak' },
  { code: 'IR', label: 'Iran, Islamic Republic of', phone: '98', translate: 'Irán' },
  { code: 'IS', label: 'Iceland', phone: '354', translate: 'Islandia' },
  { code: 'IT', label: 'Italy', phone: '39', translate: 'Italia' },
  { code: 'JE', label: 'Jersey', phone: '44', translate: 'Jersey' },
  { code: 'JM', label: 'Jamaica', phone: '1-876', translate: 'Jamaica' },
  { code: 'JO', label: 'Jordan', phone: '962', translate: 'Jordania' },
  { code: 'JP', label: 'Japan', phone: '81', translate: 'Japón' },
  { code: 'KE', label: 'Kenya', phone: '254', translate: 'Kenia' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '996', translate: 'Kirguistán' },
  { code: 'KH', label: 'Cambodia', phone: '855', translate: 'Camboya' },
  { code: 'KI', label: 'Kiribati', phone: '686', translate: 'Kiribati' },
  { code: 'KM', label: 'Comoros', phone: '269', translate: 'Comoras' },
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    phone: '1-869',
    translate: 'San Cristóbal y Nieves',
  },
  {
    code: 'KP',
    label: "Korea, Democratic People's Republic of",
    phone: '850',
    translate: 'Corea del Norte',
  },
  { code: 'KR', label: 'Korea, Republic of', phone: '82', translate: 'Corea del Sur' },
  { code: 'KW', label: 'Kuwait', phone: '965', translate: 'Kuwait' },
  { code: 'KY', label: 'Cayman Islands', phone: '1-345', translate: 'Islas Caimán' },
  { code: 'KZ', label: 'Kazakhstan', phone: '7', translate: 'Kazajistán' },
  { code: 'LA', label: "Lao People's Democratic Republic", phone: '856', translate: 'Laos' },
  { code: 'LB', label: 'Lebanon', phone: '961', translate: 'Líbano' },
  { code: 'LC', label: 'Saint Lucia', phone: '1-758', translate: 'Santa Lucía' },
  { code: 'LI', label: 'Liechtenstein', phone: '423', translate: 'Liechtenstein' },
  { code: 'LK', label: 'Sri Lanka', phone: '94', translate: 'Sri Lanka' },
  { code: 'LR', label: 'Liberia', phone: '231', translate: 'Liberia' },
  { code: 'LS', label: 'Lesotho', phone: '266', translate: 'Lesoto' },
  { code: 'LT', label: 'Lithuania', phone: '370', translate: 'Lituania' },
  { code: 'LU', label: 'Luxembourg', phone: '352', translate: 'Luxemburgo' },
  { code: 'LV', label: 'Latvia', phone: '371', translate: 'Letonia' },
  { code: 'LY', label: 'Libya', phone: '218', translate: 'Libia' },
  { code: 'MA', label: 'Morocco', phone: '212', translate: 'Marruecos' },
  { code: 'MC', label: 'Monaco', phone: '377', translate: 'Mónaco' },
  { code: 'MD', label: 'Moldova, Republic of', phone: '373', translate: 'Moldavia' },
  { code: 'ME', label: 'Montenegro', phone: '382', translate: 'Montenegro' },
  { code: 'MF', label: 'Saint Martin (French part)', phone: '590', translate: 'San Martín' },
  { code: 'MG', label: 'Madagascar', phone: '261', translate: 'Madagascar' },
  { code: 'MH', label: 'Marshall Islands', phone: '692', translate: 'Islas Marshall' },
  {
    code: 'MK',
    label: 'Macedonia, the Former Yugoslav Republic of',
    phone: '389',
    translate: 'Macedonia del Norte',
  },
  { code: 'ML', label: 'Mali', phone: '223', translate: 'Malí' },
  { code: 'MM', label: 'Myanmar', phone: '95', translate: 'Myanmar' },
  { code: 'MN', label: 'Mongolia', phone: '976', translate: 'Mongolia' },
  { code: 'MO', label: 'Macao', phone: '853', translate: 'Macao' },
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    phone: '1-670',
    translate: 'Islas Marianas del Norte',
  },
  { code: 'MQ', label: 'Martinique', phone: '596', translate: 'Martinica' },
  { code: 'MR', label: 'Mauritania', phone: '222', translate: 'Mauritania' },
  { code: 'MS', label: 'Montserrat', phone: '1-664', translate: 'Montserrat' },
  { code: 'MT', label: 'Malta', phone: '356', translate: 'Malta' },
  { code: 'MU', label: 'Mauritius', phone: '230', translate: 'Mauricio' },
  { code: 'MV', label: 'Maldives', phone: '960', translate: 'Maldivas' },
  { code: 'MW', label: 'Malawi', phone: '265', translate: 'Malaui' },
  { code: 'MX', label: 'Mexico', phone: '52', translate: 'México' },
  { code: 'MY', label: 'Malaysia', phone: '60', translate: 'Malasia' },
  { code: 'MZ', label: 'Mozambique', phone: '258', translate: 'Mozambique' },
  { code: 'NA', label: 'Namibia', phone: '264', translate: 'Namibia' },
  { code: 'NC', label: 'New Caledonia', phone: '687', translate: 'Nueva Caledonia' },
  { code: 'NE', label: 'Niger', phone: '227', translate: 'Níger' },
  { code: 'NF', label: 'Norfolk Island', phone: '672', translate: 'Isla Norfolk' },
  { code: 'NG', label: 'Nigeria', phone: '234', translate: 'Nigeria' },
  { code: 'NI', label: 'Nicaragua', phone: '505', translate: 'Nicaragua' },
  { code: 'NL', label: 'Netherlands', phone: '31', translate: 'Países Bajos' },
  { code: 'NO', label: 'Norway', phone: '47', translate: 'Noruega' },
  { code: 'NP', label: 'Nepal', phone: '977', translate: 'Nepal' },
  { code: 'NR', label: 'Nauru', phone: '674', translate: 'Nauru' },
  { code: 'NU', label: 'Niue', phone: '683', translate: 'Niue' },
  { code: 'NZ', label: 'New Zealand', phone: '64', translate: 'Nueva Zelanda' },
  { code: 'OM', label: 'Oman', phone: '968', translate: 'Omán' },
  { code: 'PA', label: 'Panama', phone: '507', translate: 'Panamá' },
  { code: 'PE', label: 'Peru', phone: '51', translate: 'Perú' },
  { code: 'PF', label: 'French Polynesia', phone: '689', translate: 'Polinesia Francesa' },
  { code: 'PG', label: 'Papua New Guinea', phone: '675', translate: 'Papúa Nueva Guinea' },
  { code: 'PH', label: 'Philippines', phone: '63', translate: 'Filipinas' },
  { code: 'PK', label: 'Pakistan', phone: '92', translate: 'Pakistán' },
  { code: 'PL', label: 'Poland', phone: '48', translate: 'Polonia' },
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    phone: '508',
    translate: 'San Pedro y Miquelón',
  },
  { code: 'PN', label: 'Pitcairn', phone: '870', translate: 'Pitcairn' },
  { code: 'PR', label: 'Puerto Rico', phone: '1', translate: 'Puerto Rico' },
  { code: 'PS', label: 'Palestine, State of', phone: '970', translate: 'Palestina' },
  { code: 'PT', label: 'Portugal', phone: '351', translate: 'Portugal' },
  { code: 'PW', label: 'Palau', phone: '680', translate: 'Palaos' },
  { code: 'PY', label: 'Paraguay', phone: '595', translate: 'Paraguay' },
  { code: 'QA', label: 'Qatar', phone: '974', translate: 'Catar' },
  { code: 'RE', label: 'Reunion', phone: '262', translate: 'Reunión' },
  { code: 'RO', label: 'Romania', phone: '40', translate: 'Rumania' },
  { code: 'RS', label: 'Serbia', phone: '381', translate: 'Serbia' },
  { code: 'RU', label: 'Russian Federation', phone: '7', translate: 'Rusia' },
  { code: 'RW', label: 'Rwanda', phone: '250', translate: 'Ruanda' },
  { code: 'SA', label: 'Saudi Arabia', phone: '966', translate: 'Arabia Saudí' },
  { code: 'SB', label: 'Solomon Islands', phone: '677', translate: 'Islas Salomón' },
  { code: 'SC', label: 'Seychelles', phone: '248', translate: 'Seychelles' },
  { code: 'SD', label: 'Sudan', phone: '249', translate: 'Sudán' },
  { code: 'SE', label: 'Sweden', phone: '46', translate: 'Suecia' },
  { code: 'SG', label: 'Singapore', phone: '65', translate: 'Singapur' },
  { code: 'SH', label: 'Saint Helena', phone: '290', translate: 'Santa Elena' },
  { code: 'SI', label: 'Slovenia', phone: '386', translate: 'Eslovenia' },
  { code: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47', translate: 'Svalbard y Jan Mayen' },
  { code: 'SK', label: 'Slovakia', phone: '421', translate: 'Eslovaquia' },
  { code: 'SL', label: 'Sierra Leone', phone: '232', translate: 'Sierra Leona' },
  { code: 'SM', label: 'San Marino', phone: '378', translate: 'San Marino' },
  { code: 'SN', label: 'Senegal', phone: '221', translate: 'Senegal' },
  { code: 'SO', label: 'Somalia', phone: '252', translate: 'Somalia' },
  { code: 'SR', label: 'Suriname', phone: '597', translate: 'Surinam' },
  { code: 'SS', label: 'South Sudan', phone: '211', translate: 'Sudán del Sur' },
  { code: 'ST', label: 'Sao Tome and Principe', phone: '239', translate: 'Santo Tomé y Príncipe' },
  { code: 'SV', label: 'El Salvador', phone: '503', translate: 'El Salvador' },
  { code: 'SX', label: 'Sint Maarten (Dutch part)', phone: '1-721', translate: 'Sint Maarten' },
  { code: 'SY', label: 'Syrian Arab Republic', phone: '963', translate: 'Siria' },
  { code: 'SZ', label: 'Swaziland', phone: '268', translate: 'Esuatini' },
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '1-649',
    translate: 'Islas Turcas y Caicos',
  },
  { code: 'TD', label: 'Chad', phone: '235', translate: 'Chad' },
  {
    code: 'TF',
    label: 'French Southern Territories',
    phone: '262',
    translate: 'Territorios Australes Franceses',
  },
  { code: 'TG', label: 'Togo', phone: '228', translate: 'Togo' },
  { code: 'TH', label: 'Thailand', phone: '66', translate: 'Tailandia' },
  { code: 'TJ', label: 'Tajikistan', phone: '992', translate: 'Tayikistán' },
  { code: 'TK', label: 'Tokelau', phone: '690', translate: 'Tokelau' },
  { code: 'TL', label: 'Timor-Leste', phone: '670', translate: 'Timor Oriental' },
  { code: 'TM', label: 'Turkmenistan', phone: '993', translate: 'Turkmenistán' },
  { code: 'TN', label: 'Tunisia', phone: '216', translate: 'Túnez' },
  { code: 'TO', label: 'Tonga', phone: '676', translate: 'Tonga' },
  { code: 'TR', label: 'Turkey', phone: '90', translate: 'Turquía' },
  { code: 'TT', label: 'Trinidad and Tobago', phone: '1-868', translate: 'Trinidad y Tobago' },
  { code: 'TV', label: 'Tuvalu', phone: '688', translate: 'Tuvalu' },
  { code: 'TW', label: 'Taiwan, Province of China', phone: '886', translate: 'Taiwán' },
  { code: 'TZ', label: 'United Republic of Tanzania', phone: '255', translate: 'Tanzania' },
  { code: 'UA', label: 'Ukraine', phone: '380', translate: 'Ucrania' },
  { code: 'UG', label: 'Uganda', phone: '256', translate: 'Uganda' },
  { code: 'US', label: 'United States', phone: '1', translate: 'Estados Unidos' },
  { code: 'UY', label: 'Uruguay', phone: '598', translate: 'Uruguay' },
  { code: 'UZ', label: 'Uzbekistan', phone: '998', translate: 'Uzbekistán' },
  {
    code: 'VA',
    label: 'Holy See (Vatican City State)',
    phone: '379',
    translate: 'Ciudad del Vaticano',
  },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '1-784',
    translate: 'San Vicente y las Granadinas',
  },
  { code: 'VE', label: 'Venezuela', phone: '58', translate: 'Venezuela' },
  {
    code: 'VG',
    label: 'British Virgin Islands',
    phone: '1-284',
    translate: 'Islas Vírgenes Británicas',
  },
  {
    code: 'VI',
    label: 'US Virgin Islands',
    phone: '1-340',
    translate: 'Islas Vírgenes Americanas',
  },
  { code: 'VN', label: 'Vietnam', phone: '84', translate: 'Vietnam' },
  { code: 'VU', label: 'Vanuatu', phone: '678', translate: 'Vanuatu' },
  { code: 'WF', label: 'Wallis and Futuna', phone: '681', translate: 'Wallis y Futuna' },
  { code: 'WS', label: 'Samoa', phone: '685', translate: 'Samoa' },
  { code: 'XK', label: 'Kosovo', phone: '383', translate: 'Kosovo' },
  { code: 'YE', label: 'Yemen', phone: '967', translate: 'Yemen' },
  { code: 'YT', label: 'Mayotte', phone: '262', translate: 'Mayotte' },
  { code: 'ZA', label: 'South Africa', phone: '27', translate: 'Sudáfrica' },
  { code: 'ZM', label: 'Zambia', phone: '260', translate: 'Zambia' },
  { code: 'ZW', label: 'Zimbabwe', phone: '263', translate: 'Zimbabue' },
];
